var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"100vw","height":"100vh"}},[_c('BaseHeaderBar',{attrs:{"title":"","showCustomerService":false,"showBackButton":true}}),_c('iframe',{attrs:{"id":"iframe","src":"https://sdk.thailand.accuauth.com/silent-liveness-h5/index.html","allow":"camera;microphone","frameborder":"0","width":"100%","height":"100%"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }